import * as Yup from 'yup';

import { useSelector } from 'react-redux';
import { REQUIRED_FIELD_ERROR } from '../../../utils/constants';

const useValidationSchema = () => {
  const validationSchema = Yup.object().shape({
    rental_object: Yup.number()
      .transform((value, originalValue) => {
        return originalValue ? Number(originalValue) : undefined;
      })
      .required(REQUIRED_FIELD_ERROR),
    start_closure: Yup.date().required(REQUIRED_FIELD_ERROR),
    end_closure: Yup.date()
      .required(REQUIRED_FIELD_ERROR)
      .test(
        'is-greater',
        'Дата окончания должна быть позже даты начала',
        function (end_closure) {
          const { start_closure } = this.parent;
          return start_closure && end_closure && end_closure > start_closure;
        },
      ),
    reason: Yup.string().required(REQUIRED_FIELD_ERROR),
  });
  return validationSchema;
};

export default useValidationSchema;
